import { Redirect, Route, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTE_PREFIX_PRE_APPT } from '../../../constants/routes';
import { resolvePreApptRedirectPath } from '../../../utils/preApptRedirectUtils';
import { isWorkflowVerified } from '../../../slices/workflow';

const PreApptRouteWrapper = ({ children, ...rest }) => {
  const { workflowId } = useParams();
  const workflowState = useSelector(({ workflow }) => workflow);
  const { data: workflow } = workflowState;

  if (!isWorkflowVerified(workflowState, workflowId)) {
    return <Redirect to={`${ROUTE_PREFIX_PRE_APPT}/${workflowId}`} />;
  }

  const redirectPath = resolvePreApptRedirectPath(workflowId, workflow);

  if (redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return <Route {...rest}>{children}</Route>;
};

export default PreApptRouteWrapper;
